/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Features_Notes_DescriptionInputs */

const en_homepage_features_notes_description = /** @type {(inputs: Homepage_Features_Notes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you hear something interesting, just click the "+note" button to take notes! No need to type - we'll record the last 2 sentences you heard, automatically!`)
};

const es_homepage_features_notes_description = /** @type {(inputs: Homepage_Features_Notes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si escuchas algo interesante, ¡solo haz clic en el botón "+nota" para tomar notas! No necesitas escribir - grabaremos las últimas 2 oraciones que escuchaste, ¡automáticamente!`)
};

/**
* | output |
* | --- |
* | "If you hear something interesting, just click the \"+note\" button to take notes! No need to type - we'll record the last 2 sentences you heard, automatically!" |
*
* @param {Homepage_Features_Notes_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_features_notes_description = /** @type {((inputs?: Homepage_Features_Notes_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Features_Notes_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_features_notes_description(inputs)
	return en_homepage_features_notes_description(inputs)
});